import Portal1 from "./documentation/portal-1.webp";
import Portal2 from "./documentation/portal-2.webp";
import Portal3 from "./documentation/portal-3.webp";
import Portal4 from "./documentation/portal-4.webp";
import Portal5 from "./documentation/portal-5.webp";
import Portal6 from "./documentation/portal-6.webp";
import Portal7 from "./documentation/portal-7.webp";
import Portal8 from "./documentation/portal-8.webp";
import Portal9 from "./documentation/portal-9.webp";
import Postman1 from "./documentation/postman-1.webp";
import Postman2 from "./documentation/postman-2.webp";
import Postman3 from "./documentation/postman-3.webp";
import Postman4 from "./documentation/postman-4.webp";
import Postman5 from "./documentation/postman-5.webp";
import Postman6 from "./documentation/postman-6.webp";
import Postman7 from "./documentation/postman-7.webp";
import Postman5Bulk from "./bulk-api-documentation/postman-5.webp";
import Postman6Bulk from "./bulk-api-documentation/postman-6.webp";
import Graphql1 from "./documentation/graphql-1.webp";
import Authentication1 from "./documentation/authentication-1.webp";
import HomePageImage from './horizontal-graph.webp';
import DefaultAPIImage from './mobile.webp';
import estimates from './estimates.webp';
import fundamentals from './fundamentals.webp';
import indexComposition from './indexcomposition.webp';
import intradayHistory from './intradayhistory.webp';
import streamingMarketData from "./streamingmarketdata.webp";

const Images = {
    Portal1,
    Portal2,
    Portal3,
    Portal4,
    Portal5,
    Portal6,
    Portal7,
    Portal8,
    Portal9,
    Postman1,
    Postman2,
    Postman3,
    Postman4,
    Postman5,
    Postman6,
    Postman7,
    Postman5Bulk,
    Postman6Bulk,
    Graphql1,
    Authentication1,
    HomePageImage,
    DefaultAPIImage,
    estimates,
    fundamentals,
    indexComposition,
    intradayHistory,
    streamingMarketData
}

export default Images;